import * as Yup from 'yup';
import type { PhoneNumberUtil } from 'google-libphonenumber';

let phoneUtilPromise: Promise<PhoneNumberUtil> | null = null;
const loadPhoneUtil = (): Promise<PhoneNumberUtil> => {
  if (!phoneUtilPromise) {
    phoneUtilPromise = import('google-libphonenumber').then((m) =>
      m.PhoneNumberUtil.getInstance()
    );
  }
  return phoneUtilPromise;
};

/** Fire-and-forget warm-up of the phone validation library. */
export const preloadPhoneUtil = (): void => {
  void loadPhoneUtil();
};

const phoneNumberValidationES = Yup.object()
  .test('valid-phone-number', 'El número celular ingresado no es válido.', async function (
    obj: any
  ) {
    const digits = (obj?.number || '').replace(/\D/g, '');
    const dialDigits = (obj?.countryDialCode || '').replace(/\D/g, '');
    if (digits.length <= dialDigits.length) {
      return this.createError({ message: 'Celular es un campo requerido.' });
    }
    try {
      const phoneUtil = await loadPhoneUtil();
      const number = phoneUtil.parse(obj.number, obj.countryCode);
      return phoneUtil.isValidNumber(number);
    } catch (e) {
      return false;
    }
  })
  .required('Celular es un campo requerido.');

const phoneNumberValidationEN = Yup.object()
  .test('valid-phone-number', 'The entered phone number is not valid.', async function (
    obj: any
  ) {
    const digits = (obj?.number || '').replace(/\D/g, '');
    const dialDigits = (obj?.countryDialCode || '').replace(/\D/g, '');
    if (digits.length <= dialDigits.length) {
      return this.createError({ message: 'Phone number is a required field.' });
    }
    try {
      const phoneUtil = await loadPhoneUtil();
      const number = phoneUtil.parse(obj.number, obj.countryCode);
      return phoneUtil.isValidNumber(number);
    } catch (e) {
      return false;
    }
  })
  .required('Phone number is a required field.');

const invoiceValidationES = Yup.object().shape({
  firstName: Yup.string().trim().required('Nombre es un campo requerido.'),
  lastName: Yup.string().trim().required('Apellido es un campo requerido.'),
  email: Yup.string()
    .trim()
    .email('Ingresa un e-mail válido.')
    .required('Email es un campo requerido.'),
  idType: Yup.string().required('Tipo de identificación es un campo requerido.'),
  idNumber: Yup.number()
    .typeError('No. de identificación es un campo requerido')
    .required('No. de identificación es un campo requerido'),
  address: Yup.string().trim().required('Dirección es un campo requerido.'),
  phoneNumber: phoneNumberValidationES,
});

const invoiceValidationEN = Yup.object().shape({
  firstName: Yup.string().trim().required('First name is a required field.'),
  lastName: Yup.string().trim().required('Last name is a required field.'),
  email: Yup.string()
    .trim()
    .email('Enter a valid e-mail.')
    .required('Email is a required field.'),
  idType: Yup.string().required('ID type is a required field.'),
  idNumber: Yup.number()
    .typeError('ID number is a required field.')
    .required('ID number is a required field.'),
  address: Yup.string().trim().required('Address is a required field.'),
  phoneNumber: phoneNumberValidationEN,
});

export { invoiceValidationES, invoiceValidationEN };
